import _ from 'lodash';
import template from './privilege-templates-permission-picker.html';

class PrivilegeTemplatesPermissionPickerController {
  $onChanges(changes) {
    if (changes.privileges && changes.privileges.currentValue) {
      this.permissions = changes.privileges.currentValue;
    }
    if (this.permissions && Object.keys(this.permissions).length && _.get(this, 'currentPreset.privileges')) {
      this.clearTree(this.permissions.privileges);
      this.setChecksRecursive();
    }
  }

  clearTree(privilege) {
    Object.keys(privilege).map((item) => {
      if (Object.prototype.toString.call(privilege[item]) === '[object Object]') {
        return this.clearTree(privilege[item]);
      }
      if (_.get(privilege, 'checked')) {
        privilege.checked = false;
      }
      return null;
    });
  }

  findObjectByPathAndSetChecks(privilege, path, check) {
    Object.keys(privilege).map((item) => {
      if (Object.prototype.toString.call(privilege[item]) === '[object Object]') {
        return this.findObjectByPathAndSetChecks(privilege[item], path, check);
      }
      if (privilege.id === path || privilege.path === path) {
        privilege.checked = check;
      }
      return null;
    });
  }

  filterDynamicPrivileges() {
    return this.model.filter(
      (privilege) => this.currentPreset.privileges.find((privilegeId) => privilegeId === privilege.id) !== undefined
    );
  }

  setChecksRecursive() {
    const currentPrivilegeSet = this.filterDynamicPrivileges();
    const { privileges } = this.permissions;
    currentPrivilegeSet.map((privilege) => {
      this.findObjectByPathAndSetChecks(privileges, privilege.id, true);
      let parentsPrivilegePaths = [];
      const privilegePathArray = privilege.displayPath.split('.');
      return privilegePathArray.map((privilegePath) => {
        if (privilegePath) {
          parentsPrivilegePaths = parentsPrivilegePaths.concat(privilegePath);
          this.findObjectByPathAndSetChecks(privileges, parentsPrivilegePaths.join('.'), true);
        }
        return privilegePath;
      });
    });
  }

  togglePrivilege(privilege, parents) {
    if (parents.length !== 0 && privilege.checked) {
      _.flattenDeep(parents).forEach((parent) => {
        parent.checked = privilege.checked;
        return parent;
      });
    }

    function markChecks(_privilege, checked) {
      _privilege.checked = checked;
      if (_privilege.privileges) {
        Object.keys(_privilege.privileges).map((subPrivilegeName) => {
          const subPrivilege = _privilege.privileges[subPrivilegeName];
          return markChecks(subPrivilege, checked);
        });
      }
    }

    markChecks(privilege, privilege.checked);

    this.editPresetPrivileges({ privileges: this.getPrivilegesArrayRecursive() });
  }

  getPrivilegesArrayRecursive() {
    const { privileges } = this.permissions;
    const checkedPrivilegesArray = [];

    function getCheckedPrivileges(_privilege, _checkedPrivilegesArray) {
      Object.keys(_privilege).map((item) => {
        if (_privilege.id && _privilege.checked && _checkedPrivilegesArray.indexOf(_privilege.id) === -1) {
          _checkedPrivilegesArray.push(_privilege.id);
        }
        if (Object.prototype.toString.call(_privilege[item]) === '[object Object]') {
          getCheckedPrivileges(_privilege[item], _checkedPrivilegesArray);
        }
        return item;
      });
    }

    getCheckedPrivileges(privileges, checkedPrivilegesArray);

    return checkedPrivilegesArray;
  }
}

export default class PrivilegeTemplatesPermissionPickerComponent {
  constructor() {
    this.template = template;
    this.controller = PrivilegeTemplatesPermissionPickerController;
    this.bindings = {
      model: '<',
      privileges: '<',
      isEditable: '<',
      currentPreset: '<',
      editPresetPrivileges: '&',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-templates-permission-picker/privilege-templates-permission-picker-component.js